import { Row, Col, Card, Placeholder } from "react-bootstrap";

const CardSkeleton = ({ numberOfCards }) => (
  <Row className="g-3">
    {[...Array(numberOfCards)].map((_, index) => (
      <Col key={index} sm={12} md={6} lg={6} xl={4} className="w-100">
        <Card className="card-skeleton">
          <Card.Body>
            <Placeholder animation="wave" className="d-flex flex-column gap-2">
              <div className="d-flex gap-4 justify-content-between">
                <div className="d-flex gap-2 w-100">
                  <Placeholder xs={3} />
                  <Placeholder xs={3} />
                </div>
                <Placeholder xs={4} />
              </div>
              <div className="d-flex gap-4 justify-content-between mb-2">
                <Placeholder xs={6} />
                <Placeholder xs={3} />
              </div>
              <div className="d-flex gap-4 justify-content-between">
                <Placeholder xs={3} />
                <Placeholder xs={2} />
              </div>
            </Placeholder>
          </Card.Body>
        </Card>
      </Col>
    ))}
  </Row>
);

export default CardSkeleton;
